import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FeedbackRequestDetailData } from "../../modules/user/feedback_requests/typeFeedbackrequest";
import { SentFeedbackRequestDetailAPICallProps } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const sentFeedbackRequestDetails = createAsyncThunk(
  "feedback/requests/sent/detail",
  async (params: SentFeedbackRequestDetailAPICallProps, storeActions) => {
    const url = `api/v1/user/feedback-requests/send/detail?feedbackRequestId=${params.feedbackRequestId}&responderId=${params.responderId}`;
    const response: any = await get(url, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const sentFeedbackRequestDetailsSlice = createSlice({
  name: "sentFeedbackRequestDetails",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: null as FeedbackRequestDetailData | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sentFeedbackRequestDetails.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(sentFeedbackRequestDetails.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(sentFeedbackRequestDetails.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = sentFeedbackRequestDetailsSlice.actions;

export default sentFeedbackRequestDetailsSlice;
